import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { isMobile } from '#src/app/shared/utils/userAgent';

import type { PetitionDetailsDataExperimentsQuery } from '../experiments.graphql';

type Experiment = PetitionDetailsDataExperimentsQuery['experiments']['relatedPetitionCardShareExperiment'];

type Params = {
	experiment: Experiment;
	utilityContext: UtilityContext;
};

/**
 * Treatment is deferred to the related-card impression (`useTreatRelatedPetitionCardShareExperiment`),
 * so `treated` is always forced to `false` here — the middle-end can return `treated: true` for a
 * returning session even with `treat: false`.
 */
export function normalizeRelatedPetitionCardShareExperiment({ experiment, utilityContext }: Params): Experiment {
	if (!shouldRunExperiment({ experiment, utilityContext })) {
		// Force control off-scope even if Experiment Service already assigned a real arm (bucketing
		// is device-agnostic) — scope wins over override.
		return { ...experiment, variation: 'control', treated: false };
	}

	return { ...experiment, treated: false };
}

function shouldRunExperiment({ experiment, utilityContext }: Params): boolean {
	return isEnabledByFC(experiment) && isMobile(utilityContext);
}

/** An `enabledIf` failure surfaces as `fallback: true`, not a distinct sentinel. */
function isEnabledByFC(experiment: Experiment): boolean {
	return !experiment.fallback;
}
